import { ProductLineName } from '@/models/products/collection';

// Models that only support grommet rib attachments, regardless of collection handle.
// This check takes priority over the collection-level pockets/grommets logic.
export const grommetOnlyModels: string[] = [
  "864FM-SQ",
  "464FM-SQ",
  "864FMC-SQ",
  "464FMC-SQ",
  "864FMA-SQ",
  "464FMA-SQ",
  "882FMC-R",
  "876FMA-R",
];

export const ribAttachment: { pockets: string[]; grommets: string[] } = {
  pockets: [
    ProductLineName.MontereyPulleyLift,
    ProductLineName.MontereyAutoTilt,
    ProductLineName.MontereyCrank,
    ProductLineName.Catalina,
    ProductLineName.Avalon
  ],
  grommets: [
    ProductLineName.Greenwich,
    ProductLineName.MontereyPulleyLift,
    ProductLineName.MontereyAutoTilt,
    ProductLineName.MontereyCrank,
    ProductLineName.Eclipse,
    ProductLineName.Aurora,
  ],
  // Laurel & Emerald Coast have no attachments
  // Giants have no attachments
}